"use client";

import React from "react";
import { ArrowDown } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
export default function HeroBanner() {
  const scrollToNextSection = () => {
    if (typeof window !== "undefined") {
      window.scrollTo({
        top: window.innerHeight,
        behavior: "smooth"
      });
    }
  };
  return <section data-section-id="262592" id="hero-banner" className="relative flex min-h-[600px] h-screen w-full flex-col overflow-hidden bg-background text-foreground">
      {}
      <div className="absolute inset-0 z-0">
        <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1679911/img/industrial_steel_hero.png" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1679911/img/industrial_steel_hero.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1679911/img/industrial_steel_hero.png-wvc-sizes" alt="Kalisch Acero Industrial" className="h-full w-full object-cover grayscale brightness-50" loading="eager" />
        {}
        <div className="absolute inset-x-0 top-0 h-48 bg-gradient-to-b from-black/80 to-transparent"></div>
        {}
        <div className="absolute inset-x-0 bottom-0 h-64 bg-gradient-to-t from-black/90 to-transparent"></div>
      </div>

      {}
      <header className="relative z-10 flex w-full items-center justify-between px-6 py-6 md:px-12">
        <Link to="/HomePage">
          <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1679911/img/kalisch_acero_logo.png" alt="Kalisch Acero" className="h-16 md:h-20" src="https://driving-lion-1.10web.cloud/wp-content/uploads/2026/05/nijnirjnriejerergerg-2.png" />
        </Link>

        <nav className="hidden items-center gap-8 md:flex">
          <Link to="/HomePage" className="text-sm font-medium text-white transition-colors hover:text-primary-400">
            INICIO
          </Link>
          <Link to="/NosotrosPage" className="text-sm font-medium text-white transition-colors hover:text-primary-400">
            NOSOTROS
          </Link>
          <Link to="/SustainabilityPage" className="text-sm font-medium text-white transition-colors hover:text-primary-400">
            SOSTENIBILIDAD
          </Link>
          <Link to="#" className="text-sm font-medium text-white transition-colors hover:text-primary-400">
            DIVISIONES
          </Link>
          <Link to="#" className="text-sm font-medium text-white transition-colors hover:text-primary-400">
            CONTACTO
          </Link>
        </nav>
      </header>

      {}
      <div className="relative z-10 mt-auto flex w-full items-end justify-between px-6 pb-12 md:px-12">
        {}
        <div className="relative">
          <span className="pointer-events-none absolute -bottom-4 -left-2 select-none font-default font-bold text-[100px] leading-none tracking-widest text-white/5 md:-bottom-8 md:-left-4 md:text-[160px]">
            DIVISIONES
          </span>
          <h1 className="relative font-default font-bold text-5xl leading-tight text-white md:text-7xl uppercase tracking-tight">
            LAS 4 DIVISIONES
          </h1>
        </div>

        {}
        <Button variant="outline" size="icon" onClick={scrollToNextSection} className="size-12 shrink-0 rounded-lg border-none bg-primary text-primary-foreground hover:bg-primary-600 md:size-14 shadow-lg transition-all" aria-label="Scorri verso il basso">
          <ArrowDown className="size-6" />
        </Button>
      </div>
    </section>;
}